import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, Routes, Route, Navigate } from 'react-router-dom';
import WithFeatureFlag from 'hocs/WithFeatureFlag';
import { Roles } from 'constants/roles';
import useSegment from '../../services/Analytics';
import usePermissions from '../../hooks/usePermissions';
import { ISidebarItem } from './types.d';
import { SideItems } from './sidebarItems';
import RenderListItem from './RenderListItem';
import RenderItemComponent from './RenderItemComponent';
import Title from './Title/Title';
import { Container, Body, SideBar, ViewOption, SidebarList } from './style';

const ServiceManagement: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [sidebarItems, setSidebarItems] = useState<Array<ISidebarItem>>([]);

  const { sendPage } = useSegment();
  const { checkPermission } = usePermissions();

  useEffect(() => {
    const isManager = checkPermission(Roles.MANAGER);

    const idxVerifiedTemplates = SideItems.map((element) => element.key).indexOf('verified-templates');

    if (idxVerifiedTemplates > -1 && !isManager) {
      SideItems.splice(idxVerifiedTemplates, 1);
    }

    setSidebarItems(
      SideItems.map((item) => ({
        ...item,
        name: t(item.key),
        subItems:
          item.subItems?.map((subItem) => ({
            ...subItem,
            name: t(subItem.key),
          })) || [],
      }))
    );
    sendPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Container>
      <Title title="managementChats" onClose={() => navigate('/')} />
      <Body>
        <SideBar>
          <SidebarList disablePadding>
            {sidebarItems.map((item, index) => {
              const itemKey = item.key;
              const featureFlag = item.featureFlagName;
              return (
                <React.Fragment key={itemKey}>
                  {featureFlag ? (
                    <WithFeatureFlag
                      featureFlag={`${featureFlag}`}
                      WrappedComponent={<RenderListItem index={index} item={item} />}
                    />
                  ) : (
                    <RenderListItem key={itemKey} index={index} item={item} />
                  )}
                </React.Fragment>
              );
            })}
          </SidebarList>
        </SideBar>
        <ViewOption>
          <Routes>
            <Route index element={<Navigate to="users" replace />} />
            <Route path=":section" element={<RenderItemComponent />} />
            <Route path=":section/:subsection" element={<RenderItemComponent />} />
          </Routes>
        </ViewOption>
      </Body>
    </Container>
  );
};

export default ServiceManagement;
